import { render, staticRenderFns } from "./NumberInputSize.vue?vue&type=template&id=3070b444"
import script from "./NumberInputSize.vue?vue&type=script&lang=js"
export * from "./NumberInputSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports